import React, { useState } from "react";
import PropTypes from "prop-types";

const SmallBox = ({ chosenValue, setChosenValue, text, keyName, size }) => {
  const [isOpen, setOpen] = useState(chosenValue.includes(keyName));

  return (
    <button
      className={`review_size_filter__box review_size_filter_${size}_box ${isOpen ? "dark_btn" : "light_btn"}`}
      onClick={() => {
        setOpen(isOpen ? false : true);
        const index = chosenValue.indexOf(keyName);
        if (isOpen) {
          if (index !== -1) {
            chosenValue.splice(index, 1);
          }
        } else {
          chosenValue.push(keyName);
        }
        setChosenValue(chosenValue);
      }}>
      <span className="reviews_filters-size_filter-text">{text}</span>
    </button>
  );
};

SmallBox.propTypes = {
  chosenValue: PropTypes.array.isRequired,
  setChosenValue: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  keyName: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};

export default SmallBox;
